import { createClient } from '@supabase/supabase-js'

// Supabase publishable configuration is safe for browser clients.
// Environment values override these production defaults when provided.
const PROD_SUPABASE_URL = 'https://grusoxengxpkfhgwibov.supabase.co'
const PROD_SUPABASE_PUBLISHABLE_KEY = 'sb_publishable_eaneeo80mUx4syYZlFNZqQ_hk3JefNa'

const url = (import.meta.env.VITE_SUPABASE_URL as string | undefined)?.trim() || PROD_SUPABASE_URL
const key = (import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string | undefined)?.trim() || PROD_SUPABASE_PUBLISHABLE_KEY

export const supabase = createClient(url, key, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
})
